export const SET_DOWNLOADED_LIST_VIEWS = 'SET_DOWNLOADED_LIST_VIEWS';
export const UNSET_DOWNLOADED_LIST_VIEWS = 'UNSET_DOWNLOADED_LIST_VIEWS';
